import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from 'src/environments/environment';
import packageJson from '../../../package.json';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'ad-footer',
  imports: [UpperCasePipe],
  template: `
    <footer class="footer border-top">
      <div class="container-fluid px-lg-4">
        <div class="d-flex footer-row justify-content-between align-items-center">
          <!-- Left Side: Environment & Version -->
          <div class="d-flex align-items-center gap-2"></div>

          <!-- Right Side: Copyright -->
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted">©2026 CIGP</span>
            <span class="text-muted">v{{ version }}</span>
            @if (environment !== 'production') {
              <span class="badge text-warning-emphasis bg-warning-subtle border border-warning">
                {{ environment | uppercase }}
              </span>
            }
          </div>
        </div>
      </div>
    </footer>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    .footer {
      font-size: calc(var(--cigp-font-size-xs) + 0.05rem);
      padding: var(--cigp-spacing-sm) 0;
      min-height: var(--cigp-spacing-2xl);
      line-height: var(--cigp-line-height-tight);
      background-color: var(--cigp-base-100);
      border-top-color: var(--cigp-nav-border);
    }

    [data-theme='dark'] .footer {
      background-color: var(--cigp-base-100);
    }

    .container-fluid {
      padding-top: 0;
      padding-bottom: 0;
    }

    .d-flex {
      min-height: auto;
    }

    .badge {
      font-size: calc(var(--cigp-font-size-xs) - 0.1rem);
    }

    .text-muted {
      color: var(--cigp-neutral-content);
    }

    @media (max-width: 575.98px) {
      .footer {
        font-size: var(--cigp-font-size-xs);
      }

      /* Only stack the main footer row vertically; avoid changing all .d-flex globally */
      .footer-row {
        flex-direction: column;
        gap: var(--cigp-spacing-xs);
        text-align: center;
        align-items: center;
      }

      .footer-left,
      .footer-right {
        justify-content: center;
        font-size: var(--cigp-font-size-xs);
      }
    }
  `
})
export class FooterComponent {
  protected environment = environment.env;
  protected version = packageJson.version;
}
